import ShopBasicSettingsForm from './shop-basic-settings-form';

export * from './shop-basic-settings-form';
export default ShopBasicSettingsForm;
